var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSignatureImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6451_11958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8042 8.23535H5.14453C4.59225 8.23535 4.14453 8.68307 4.14453 9.23535V30.5169C4.14453 31.0692 4.59225 31.5169 5.14453 31.5169H35.8042C36.3565 31.5169 36.8042 31.0692 36.8042 30.5169V9.23535C36.8042 8.68307 36.3565 8.23535 35.8042 8.23535Z",
    stroke: "#46B476",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 22.7113L16.522 16L22.965 22.9179L26.7578 20.0949L33 25",
    stroke: "#46B476",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0875 15.3084C26.0875 16.629 25.0157 17.7008 23.6951 17.7008C22.3746 17.7008 21.3027 16.6305 21.3027 15.3084C21.3027 13.9863 22.3731 12.916 23.6951 12.916C25.0172 12.916 26.0875 13.9863 26.0875 15.3084Z",
    stroke: "#46B476",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 12V28H25",
    stroke: "#46B476",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12H8V28",
    stroke: "#46B476",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6451_11958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 26,
    fill: "white",
    transform: "translate(3 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignatureImg);
export default __webpack_public_path__ + "static/media/icon_signatureImg.eda8aa4b568db49e1d4815823be51e2b.svg";
export { ForwardRef as ReactComponent };